import { render, staticRenderFns } from "./extensionApproval.vue?vue&type=template&id=e5f92a0a&scoped=true"
import script from "./extensionApproval.vue?vue&type=script&lang=js"
export * from "./extensionApproval.vue?vue&type=script&lang=js"
import style0 from "./extensionApproval.vue?vue&type=style&index=0&id=e5f92a0a&prod&scoped=true&lang=css"
import style1 from "./extensionApproval.vue?vue&type=style&index=1&id=e5f92a0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f92a0a",
  null
  
)

export default component.exports